<template>
  <div class="story-block">
    <div class="container">
      <h3>Your Story Awaits</h3>
      <h2>Here's How to Join</h2>

      <div class="cards">
        <div class="card">
          <div class="image">
            <img src="./images/join-icon-01.svg">
          </div>
          <div class="content">
            <strong>Explore the <router-link :to="{name: 'world'}">TRUE World</router-link></strong>
            <p>Dive into our universe and discover how each game is woven into the grand narrative.</p>
          </div>
        </div>
        <div class="card">
          <div class="image">
            <img src="./images/join-icon-02.svg">
          </div>
          <div class="content">
            <strong>Join the <router-link :to="{name: 'community'}">TRUE Community</router-link></strong>
            <p>Connect with fellow adventurers on Telegram, Twitter, and beyond.</p>
          </div>
        </div>
        <div class="card">
          <div class="image">
            <img src="./images/join-icon-03.svg">
          </div>
          <div class="content">
            <strong>Unlock the <router-link :to="{name: 'market'}">TRUE Power</router-link></strong>
            <p>Learn how NFTs, Truecoin, and TRUE Wallet redefine what gaming can be.</p>
          </div>
        </div>
        <div class="card">
          <div class="image">
            <img src="./images/join-icon-04.svg">
          </div>
          <div class="content">
            <strong><router-link :to="{name: 'token'}">Make Your Mark</router-link></strong>
            <p>Participate in tournaments, shape the future of TRUE, and become part of the legend.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'story-block',
}
</script>

<style lang="less" scoped>
  .story-block {
    padding-top: 140px;
    padding-bottom: 100px;

    > .container {
      > h3 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 45px;
        text-align: center;
        margin-bottom: 2px;
        background: linear-gradient(90.62deg, #DF60FF 0%, #9C94FF 49.03%, #44E9C3 62.94%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      > h2 {
        color: #FFF;
        font-family: Poppins;
        font-weight: 700;
        font-size: 50px;
        line-height: 64px;
        text-align: center;
        margin-bottom: 16px;
      }
      > .cards {
        display: flex;
        gap: 20px;
        margin-bottom: 40px;
        > .card {
          width: 280px;
          background: #C9D8FF0F;
          border-radius: 40px;
          padding: 50px 30px 46px 30px;
          display: flex;
          flex-direction: column;
          align-items: center;
          > .image {
            margin-bottom: 24px;
            > img {
              display: block;
            }
          }
          > .content {
            text-align: center;
            > strong {
              display: block;
              color: #FFF;
              font-family: Poppins;
              font-weight: 600;
              font-size: 18px;
              line-height: 28px;
              margin-bottom: 6px;
              > a {
                line-height: 20px;
                color: #FFF;
                text-decoration: underline;
                text-underline-offset: 2px;
              }
            }
            > p {
              color: #FFFFFF99;
              font-family: Poppins;
              font-weight: 500;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
      > .explore {
        > strong {
          display: block;
          color: #FFFFFF99;
          font-family: Poppins;
          font-weight: 500;
          font-size: 20px;
          line-height: 100%;
          text-align: center;
          margin-bottom: 15px;
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 190px;
            height: 60px;
            border-radius: 14px;
            transition: all .2s;
            color: #fff;
            font-size: 16px;
            line-height: 24px;
            border: 1px solid hsla(0, 0%, 100%, .2);
            &:hover {
              border-color: #fff;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1439px) {
    .story-block {
      padding-top: 45px;
      padding-bottom: 50px;

      > .container {
        > h3 {
          font-size: 24px;
          line-height: 32px;
          margin-bottom: 0;
        }
        > h2 {
          color: #FFF;
          font-family: Poppins;
          font-weight: 700;
          font-size: 36px;
          line-height: 50px;
          margin-bottom: 30px;
        }
        > .cards {
          display: flex;
          gap: 15px;
          margin-bottom: 0;
          > .card {
            width: 200px;
            border-radius: 30px;
            padding: 30px 20px 22px 20px;
            > .image {
              margin-bottom: 20px;
            }
            > .content {
              text-align: center;
              > strong {
                font-size: 16px;
                line-height: 24px;
                margin-bottom: 10px;
              }
              > p {
                font-size: 14px;
                line-height: 22px;
              }
            }
          }
        }
        > .explore {
          > strong {
            display: block;
            color: #FFFFFF99;
            font-family: Poppins;
            font-weight: 500;
            font-size: 20px;
            line-height: 100%;
            text-align: center;
            margin-bottom: 15px;
          }
          > .buttons {
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
            > a {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 190px;
              height: 60px;
              border-radius: 14px;
              transition: all .2s;
              color: #fff;
              font-size: 16px;
              line-height: 24px;
              border: 1px solid hsla(0, 0%, 100%, .2);
              &:hover {
                border-color: #fff;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .story-block {
      padding-top: 60px;
      padding-bottom: 40px;

      > .container {
        > h3 {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 0;
        }
        > h2 {
          color: #FFF;
          font-family: Poppins;
          font-weight: 700;
          font-size: 30px;
          line-height: 40px;
          margin-bottom: 30px;
        }
        > .cards {
          display: flex;
          gap: 16px;
          margin-bottom: 0;
          flex-wrap: wrap;
          > .card {
            width: 326px;
            border-radius: 30px;
            padding: 30px 20px 22px 20px;
            > .image {
              margin-bottom: 20px;
              > img {
                width: 90px;
              }
            }
            > .content {
              text-align: center;
              > strong {
                font-size: 16px;
                line-height: 24px;
                margin-bottom: 10px;
              }
              > p {
                font-size: 14px;
                line-height: 22px;
              }
            }
          }
        }
        > .explore {
          > strong {
            display: block;
            color: #FFFFFF99;
            font-family: Poppins;
            font-weight: 500;
            font-size: 20px;
            line-height: 100%;
            text-align: center;
            margin-bottom: 15px;
          }
          > .buttons {
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
            > a {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 190px;
              height: 60px;
              border-radius: 14px;
              transition: all .2s;
              color: #fff;
              font-size: 16px;
              line-height: 24px;
              border: 1px solid hsla(0, 0%, 100%, .2);
              &:hover {
                border-color: #fff;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .story-block {
      padding-top: 60px;
      padding-bottom: 60px;

      > .container {
        > h3 {
          font-size: 14px;
          line-height: 100%;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 20px;
          line-height: 26px;
          margin-bottom: 20px;
        }
        > .cards {
          display: flex;
          gap: 16px;
          margin-bottom: 0;
          flex-wrap: wrap;
          > .card {
            width: 100%;
            border-radius: 30px;
            padding: 20px 15px;
            > .image {
              margin-bottom: 10px;
              > img {
                width: 70px;
              }
            }
            > .content {
              text-align: center;
              > strong {
                font-size: 14px;
                line-height: 22px;
                margin-bottom: 4px;
              }
              > p {
                font-size: 12px;
                line-height: 20px;
              }
            }
          }
        }
        > .explore {
          > strong {
            display: block;
            color: #FFFFFF99;
            font-family: Poppins;
            font-weight: 500;
            font-size: 20px;
            line-height: 100%;
            text-align: center;
            margin-bottom: 15px;
          }
          > .buttons {
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
            > a {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 190px;
              height: 60px;
              border-radius: 14px;
              transition: all .2s;
              color: #fff;
              font-size: 16px;
              line-height: 24px;
              border: 1px solid hsla(0, 0%, 100%, .2);
              &:hover {
                border-color: #fff;
              }
            }
          }
        }
      }
    }
  }
</style>
